// var menu_links = document.querySelectorAll(".active .category_link");
// console.log("sub",menu_links)

// console.log("submenu_categories",div_parent)
// for(i = 0; i <menu_links.length; i++){
//   var arr = [];
//   arr.push(menu_links[i].getAttribute('data-target'));
//   console.log("arr",arr)
// }

function showCategoryMenu(event) {
  console.log(event.currentTarget);
  var submenu_a = document.querySelectorAll(".category_link");
  for (i = 0; i <= submenu_a.length; i++) {
    if (event.currentTarget == submenu_a[i]) {
      event.currentTarget.classList.remove("text-dark");
      event.currentTarget.classList.add("active");
    } else {
      if (submenu_a[i]) {
        submenu_a[i].classList.add("text-dark");
      }
    }
  }
  const window_url = window.location.href;
  const split_data = window_url.split("#");
  const title = "";
  const state = "";

  setTimeout(() => {
    window.history.pushState(
      {
        path: split_data[0],
      },
      "",
      split_data[0]
    );
  }, 5);
}
window.scrollTo(0, 0);




class templateCollectionJS {
  constructor() {
      this.showMoreDescription();
  }

  showMoreDescription(){
    document.addEventListener('click', event => {
      if(event.target.closest('[data-readmore]')){
         event.preventDefault();
        document.querySelector(".product-description-full").style.display = "block"
        document.querySelector(".product-description-short").style.display = "none";
      }

      if(event.target.closest('[data-readless]')){
         event.preventDefault();
        document.querySelector(".product-description-full").style.display = "none"
        document.querySelector(".product-description-short").style.display = "block";
      }
    })
}
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();